import React from "react";
import {useSelector} from "react-redux";
import Pagination from "../pagination";
import NoteComponent from "./NoteComponent";

const NotesList = ({notes, totalPages, setNotes, currentPage, setCurrentPage}) => {
  return notes.length > 0 ? (
    <>
      <div className="d-flex justify-content-center mt-4">
        <Pagination
          total_pages={totalPages}
          currentPage={currentPage}
          onPageChange={(page) =>
            setCurrentPage(page.selected + 1)
          }/>
      </div>
      {
        notes.sort((a, b) => b.starred - a.starred).map((note) => {
          return (
            <NoteComponent note={note} key={note.id} setNotes={setNotes}/>
          )
        })
      }
    </>
  ) : <div className="text-center p-3">No Notes</div>
}

export default NotesList;
